module.exports = __webpack_public_path__ + "static/img/sm_ct.a7f6eaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chanpin/sm_ct.png
// module id = 2/j1
// module chunks = 1